import defaultTheme from "./default";
import customTheme from "./custom";

const themes = {
  defaultTheme,
  customTheme,
};

export const themeConfig = {
  topbar: "theme7",
  sidebar: "theme7",
  layout: "defaultTheme",
  theme: "defaultTheme",
};
export default themes;
